<template>
  <div class="image-container">
    <transition name="slide-fade" mode="out-in">
      <img key=1 v-if="this.actualStrength === 0" class="strength-level" src="../assets/images/strength_lvl_0.svg"/>
      <img key=2 v-else-if="this.actualStrength === 1" class="strength-level" src="../assets/images/strength_lvl_1.svg"/>
      <img key=3 v-else-if="this.actualStrength === 2" class="strength-level" src="../assets/images/strength_lvl_2.svg"/>
      <img key=4 v-else-if="this.actualStrength === 3" class="strength-level" src="../assets/images/strength_lvl_3.svg"/>
      <img key=5 v-else class="strength-level" src="../assets/images/strength_lvl_4.svg"/>
    </transition>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'StrengthAnimation',
  props: ['strength'],
  data () {
    return {
      actualStrength: this.strength
    }
  },
  watch: {
    strength: _.debounce(function () {
      this.actualStrength = this.strength
    }, 400)
  }
}
</script>

<style>
.image-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  width: 360px;
  height: 324px;
  margin-right: 32px;
}
.slide-fade-enter-active,
.slide-fade-leave-enter {
    transform: translateX(0);
    opacity: .5;
    transition: all .4s linear;
}
.slide-fade-enter,
.slide-fade-leave-to {
    transform: translateX(-100%);
    opacity: 0;
}
img.strength-level {
  width: 100%;
}

@media only screen and (max-width: 1024px) {
  .image-container {
    margin: -10px 0 32px 0;
    max-width: 300px;
    height: 270px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/StrengthAnimation.vue